import React from 'react';
import { PageLayout } from '@ferreri/prever-component-lib/nextjs';
import { ValidSessionRoute } from '@ferreri/minato-auth-react';
import { PAGE_TITLE } from 'utils/pageTitle';
import { PetCremation } from 'modules/pet/PetCremation';

export default function PetCremationPage() {
  return (
    <ValidSessionRoute
      loadingComponent={
        <PageLayout title={PAGE_TITLE.cremation}>
          <PetCremation />
        </PageLayout>
      }
    >
      <PageLayout title={PAGE_TITLE.cremation}>
        <PetCremation />
      </PageLayout>
    </ValidSessionRoute>
  );
}
